<div class="wrap-row text operation">
    <div class="wrap-row-col-top">
        <div class="col-name">
            <span>{{ operation.name }}</span>
        </div>
        <div class="hr"></div>
        <div class="col-status">{{ operation.status | uppercase }}</div>
        <div class="hr"></div>
        <div class="col-action">
            {{ operation.before }}
            <span class="arrow">&#8594;</span>
            {{ operation.after }}
        </div>
    </div>
    <div class="wrap-row-col-detail text-small">
        <p>
            {{ operation.id }}<span>&#x2022;</span>
            made by
            {{
                userNamePrefix.concat(".", operation.user.userRole.role)
                    | translate
            }}<span>&#x2022;</span>occurred on
            {{ operation.datetime | date: "yyyy/MM/dd" : "UTC" }} at
            {{ operation.datetime | date: "HH:mm" : "UTC" }} UTC
        </p>
    </div>
</div>
